import { render, staticRenderFns } from "./MemberGradeEvaluation.vue?vue&type=template&id=c6060ab6&"
import script from "./MemberGradeEvaluation.vue?vue&type=script&lang=ts&"
export * from "./MemberGradeEvaluation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports